export default function marketplace(data) {
  if (data === 1) return "Análise de Boi";
  if (data === 2) return "Análise de Soja";
  if (data === 3) return "Análise de Milho";
  if (data === 8) return "Análise de Leite";
  if (data === 7) return "Análise de Frango";
  if (data === 9) return "Análise de Suínos";
  if (data === 10) return "Rural Business 5 minutos";
}
